(() => {
  const WIDGET_ID = 'judgeme_product_reviews';
  const TITLE_SELECTOR = '.jdgm-rev-widg__title';

  const convertToDiv = (el) => {
    if (!el || el.tagName === 'DIV') return;

    const div = document.createElement('div');

    for (const attr of el.attributes) {
      div.setAttribute(attr.name, attr.value);
    }

    div.append(...el.childNodes);
    el.replaceWith(div);
  };

  const convertTitlesWithin = (root) => {
    root.querySelectorAll(TITLE_SELECTOR).forEach(convertToDiv);
  };

  const watchWidget = (widget) => {
    convertTitlesWithin(widget);

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.(TITLE_SELECTOR)) convertToDiv(node);
          else convertTitlesWithin(node);
        });
      }
    }).observe(widget, { childList: true, subtree: true });
  };

  const existingWidget = document.getElementById(WIDGET_ID);

  if (existingWidget) {
    watchWidget(existingWidget);
    return;
  }

  const bodyObserver = new MutationObserver((_mutations, observer) => {
    const widget = document.getElementById(WIDGET_ID);
    if (widget) {
      observer.disconnect();
      watchWidget(widget);
    }
  });

  bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
